
export const pathalogyColumns = [
 
    {
        field: 'testName',
        headerName: 'Test Name',
        width: 250,
        editable: true,
    },
    {
        field: 'testCode',
        headerName: 'Test Code',
        width: 250,
        editable: true,
    },
    {
        field: 'departmentName',
        headerName: 'Department Name',
        width: 250,
        editable: true,
    },
  
];
